package com.ervasstudio.tracoemovimento.pages.projecto

import androidx.compose.runtime.Composable
import com.ervasstudio.tracoemovimento.util.Res
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.ObjectFit
import com.varabyte.kobweb.compose.css.TextAlign
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.cursor
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxHeight
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.fontFamily
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.lineHeight
import com.varabyte.kobweb.compose.ui.modifiers.objectFit
import com.varabyte.kobweb.compose.ui.modifiers.onClick
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.position
import com.varabyte.kobweb.compose.ui.modifiers.textAlign
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.silk.components.graphics.Image
import com.varabyte.kobweb.silk.components.text.SpanText
import org.jetbrains.compose.web.css.Position
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px

@Composable
fun CtaListaDeEspera(isMobile: Boolean, onClick: () -> Unit) {
    Row(
        modifier = Modifier
            .fillMaxWidth()
            .padding(top = if (isMobile) 24.px else 50.px, leftRight = if (isMobile) 16.px else 100.px),
        horizontalArrangement = Arrangement.Center
    ) {
        Box(
            modifier = Modifier
                .width(if (isMobile) 100.percent else 40.percent)   // era 40.percent
                .position(Position.Relative)
                .cursor(Cursor.Pointer)
                .onClick { onClick() },
            contentAlignment = Alignment.CenterStart
        ) {
            Image(
                modifier = Modifier.fillMaxWidth().objectFit(ObjectFit.Fill),
                src = Res.Image.bgstyle,
            )

            Column(
                horizontalAlignment = Alignment.Start,
                verticalArrangement = Arrangement.Top,
                modifier = Modifier
                    .fillMaxHeight()
                    .padding(
                        top = if (isMobile) 24.px else 60.px,
                        right = if (isMobile) 12.px else 20.px,
                        bottom = if (isMobile) 12.px else 20.px,
                        left = if (isMobile) 16.px else 40.px,
                    )
            ) {
                SpanText(
                    modifier = Modifier
                        .fontSize(if (isMobile) 16.px else 32.px)   // era 32.px
                        .fontFamily("museomodernoboldItalic")
                        .fontWeight(FontWeight.Bold)
                        .lineHeight(1)
                        .color(Colors.Black),
                    text = "Quero entrar na lista de espera"
                )
                SpanText(
                    modifier = Modifier
                        .fontSize(if (isMobile) 16.px else 32.px)   // era 32.px
                        .fontFamily("museomodernoboldItalic")
                        .fontWeight(FontWeight.Bold)
                        .lineHeight(1.5)
                        .textAlign(TextAlign.Start)
                        .color(Colors.Black),
                    text = "para próxima turma"
                )
            }
        }
    }
}